import React,{Component} from 'react'
import {Table,Button,Modal,Select,Switch  } from 'antd'
import {getGoodList,setVideo} from '_src/api/api'

import './style/index.less'
import { red } from 'ansi-colors';

export default class VideoList extends Component{
	constructor(props){
		super(props)
		this.pageNum = 0
    	this.totalElements = 0
		this.state = {
			tableLoading:true,
			dataList: [],
			visible:false,
			id:'',
			enable:true,
			newUserSort:1,
			oldUserSort:1,
		}
	}
	componentDidMount(){
		this.LoadData()
	}

	LoadData = (callback) => {
		this.setState(() => ({
			tableLoading: true
		}))
		getGoodList({
			pageNum:this.pageNum,
			pageSize:10,
			isVideo:true
		}).then(res => {
			callback && callback()
			const {data:{content,totalElements}} = res
			this.setState({
				tableLoading:false
			})
			this.totalElements = totalElements
			const dataList = content && content.map(item => {
				const {goodsSn,picUrl,goodsName,goodsReward,id,goodsVideoSettings} = item
				const baseInfo = {goodsSn,picUrl,goodsName,goodsReward,goodsVideoSettings}
				 /**
				 * goodsReward 商品积分{
				 * `watchCount`  '观看视频时常 单位秒', 
				 * `watchReward` '观看视频时常 获得多少积分',   
				 * `browsCount`   浏览商品时常 单位秒',  
				 * `browsReward` '浏览商品时常 获得多少积分',   
				 * `totalCount`  '该商品设置的总积分'}
				 */
				const {watchCount,watchReward,totalCount} = goodsReward || { watchCount: '无', watchReward: '无', totalCount:'无' }
				const {newUserSort,oldUserSort} = goodsVideoSettings || {newUserSort:'未设置',oldUserSort:'未设置'}
				const RewardInfo = { watchCount, watchReward, totalCount}
				const ViedoInfo = {newUserSort,oldUserSort}
				return { key: goodsSn, ...baseInfo, ...RewardInfo, id, ViedoInfo }
			})
			
			this.setState(() => ({
				dataList: [...dataList],
			  }))

		})
	}
	setTableLoad () {
		this.setState(() => ({
		  tableLoading: true
		}))
	  }
	pageChange (pageNum) {
		this.setTableLoad()
		this.pageNum = pageNum - 1
		this.LoadData()
	}

	handleOk = e => {
		let param = {
			enable:this.state.enable,
			newUserSort:this.state.newUserSort,
			oldUserSort:this.state.oldUserSort
		}
		this.setState({ loading: true })
		setVideo(this.state.id,param).then(res => {
			this.setState({
				visible: false,
				loading:false,
				newUserSort:1,
				oldUserSort:1
			});
			this.LoadData()
		}).catch(e => {
			this.setState({
				visible:false,
				loading:false
			})
		})	
	  };
	
	  handleCancel = e => {
		this.setState({
		  visible: false,
		});
	  };

	columns = () => ([
		{
			title:'商品编号',
			dataIndex:'goodsSn'
		},
		{
			title:'商品图片',
			dataIndex: 'picUrl',
      		render: (url) => <img src={url} style={{ width: 100 }} alt="" />
		},
		{
			title:'商品名称',
			dataIndex: 'goodsName',
		},
		{
			title:'积分',
			width: 150,
			render: item => (
				item
				? (
					<div>
					<div>观看视频时长：{item.watchCount} 秒</div>
					<div>奖励积分：{item.watchReward}</div>
					<div>总积分：{item.totalCount}</div>
					</div>
				)
				: '无奖励'
			)
		},
		{
			title:'新用户',
			dataIndex:'ViedoInfo.newUserSort',
			
		},
		{
			title:'老用户',
			dataIndex:'ViedoInfo.oldUserSort'
		},
		{
			title:'操作',
			dataIndex:'id',
			render:(id) => (
				<div className="examine">
					<Button size="small" type="primary" style={{ paddingLeft: 5, paddingRight: 5 }}
						onClick={e => {
							this.setState({
								visible:true,
								id:id
							})
						}}
					>设置</Button>
				</div>
			)
		}
	])


 	render() {
		 const {dataList} = this.state
		 const { Option } = Select
		 const sortData = [1,2,3,4,5]
		return (
		<div className="GoodList">
			<div className="good_table">
				<Table
					loading={this.state.tableLoading}
					bordered
					size="middle"
					columns={this.columns()}
					dataSource={dataList}
					pagination={{
						current: (this.pageNum + 1),
						total: this.totalElements,
						onChange: (page) => { this.pageChange(page) }
			
					}}
				></Table>
			</div>
			<Modal
				title="设置优先级"
				visible={this.state.visible}
				onOk={this.handleOk}
				onCancel={this.handleCancel}
				>
				<p style={{textAlign:'center',color:'red'}}>数字越小等级越高</p>
				<div className="list" style={{marginLeft:110,marginBottom:10}}>
					<span style={{marginTop:5}}>新用户：</span>
					<Select defaultValue="1" style={{ width: 150 }} onChange={value =>this.setState({newUserSort:value})}>
						{
							sortData.map(i => (
								<Option value={i} key={i}>{i}</Option>
							))
						}
					</Select>
				</div>
				<div className="list" style={{marginLeft:110,marginBottom:10}}>
					<span style={{marginTop:5}}>老用户：</span>
					<Select defaultValue="1" style={{ width: 150 }} onChange={value =>this.setState({oldUserSort:value})}>
						{
							sortData.map(i => (
								<Option value={i} key={i}>{i}</Option>
							))
						}
					</Select>
					
				</div>
				<div className="list" style={{marginLeft:110}}>
					<span style={{marginRight:15}}>状态：</span>
					<Switch defaultChecked onChange={checked => this.setState({enable:checked})}/>
				</div>
			</Modal>
		</div>
		)
	}
}